import RetentionPersonnel from "./RetentionPersonnel";

export default RetentionPersonnel;
